module.exports = __webpack_public_path__ + "media/partners/blue-buffalo-1f8b0522.svg";